import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		isLogin: false
	},
	mutations: {
		setUserLogin(state, data) {
			state.isLogin = data
		},
	},
	modules: {}
})